<template>
  <div class="replies">
    <v-autocomplete
      v-model="selectedBlocks"
      :items="blocks"
      item-text="name"
      item-value="id"
      chips
      return-object
      outline
      solo
      :multiple="true"
    >
      <template v-slot:selection="data">
        <v-chip :selected="data.selected" close @input="removeBlock(data.item)">
          <strong>{{ data.item.name }}</strong
          >&nbsp;
          <a
            v-if="allowNewTabs"
            :href="`/build?block=${data.item.id}`"
            target="_blank"
            class="ml-1"
          >
            <v-icon color="primary" size="15">open_in_new</v-icon>
          </a>
        </v-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import common from "../../../../utils/common";
import VTextareaAutocomplete from "../../../common/v-textarea-autocomplete";
import _ from "lodash";
export default {
  name: "selectBlocks",
  props: {
    excludeBlocks: {
      type: Array,
      default: () => {
        return [];
      },
    },
    blocks: {
      type: Array,
      default: () => {
        return [];
      },
    },
    singleBlock: {
      type: Boolean,
      default: false,
    },
    autocompleteVariables: {
      type: Boolean,
      default: false,
    },
    allowNewTabs: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedBlocks: this.excludeBlocks,
    };
  },
  mounted() {
    if (this.autocompleteVariables) {
      this.getVariables();
    }
  },
  methods: {
    removeBlock(block) {
      let index = this.selectedBlocks.indexOf(block.id);
      this.selectedBlocks.splice(index, 1);
    },
    getVariables() {
      this.$http_bot
        .get("/blocks/variables/available")
        .then((response) => {
          const variables = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].variable !== "") {
              variables.push(response.data[i]);
            }
          }
          variables.push({ variable: "channel" });
          this.$store.dispatch("setVariables", variables);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            common.logOut();
          }
        });
    },
  },
  watch: {
    selectedBlocks(newVal) {
      this.$emit("onBlocksUpdate", {
        blocks: newVal,
      });
    },
  },
};
</script>

<style>
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0;
  margin-top: -10px;
}
</style>
